import { environment } from './environment';
import { Config } from './config.model';
import { PlatformHostIntegration } from 'src/app/integrations/models/platform-host-integration.enum';
import { PlatformSesionSelector } from 'src/app/integrations/models/platform-sesion-selector.enum';
import { PlatformIntegration } from 'src/app/integrations/models/platform-integration.enum';

export const loadEnvironment = async () => {
  const url = window.location.href;

  if (url.includes(PlatformHostIntegration.aeroMHost)) {
    window.localStorage.setItem(
      PlatformSesionSelector.currentPlatform,
      PlatformIntegration.salesforce
    );
  } else {
    window.localStorage.setItem(
      PlatformSesionSelector.currentPlatform,
      PlatformIntegration.default
    );
  }

  return fetch(`/assets/env/env.${environment.name}.json`)
    .then((response) => response.json())
    .then((external: Config) => Object.assign(environment, external));
};
